import { lmsClient } from "api";

const SuspendSplit = {};

function buildQuery(params) {
  return Object.entries(params)
    .filter(([_, v]) => v !== null && v !== undefined && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
}

SuspendSplit.postSuspendSplit = function (data) {
  return lmsClient({
    url: `/lms/SuspendSplit/SuspendSplit`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "x-requestId": data?.id,
    },
    data: data?.data,
  });
};

SuspendSplit.getSuspendSplit = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;

  const params = {
    pageSize: data.pageSize,
    pageIndex: decrementIndex,
    description: data?.description,
    amountFrom: data?.amountFrom,
    amountTo: data?.amountTo,
    bankAccountId: data?.bankAccountId,
    referenceNo: data?.referenceNo,
    postingDate: data?.postingDate,
  };
  return lmsClient({
    url: `/lms/SuspendSplit/searchListSuspendSplit?${buildQuery(params)}`,
    method: "get",
  });
};

SuspendSplit.getApprovalSuspendSplit = function (data) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;

  const params = {
    pageSize: data.pageSize,
    pageIndex: decrementIndex,
    description: data?.description,
    amountFrom: data?.amountFrom,
    amountTo: data?.amountTo,
    bankAccountId: data?.bankAccountId,
    referenceNo: data?.referenceNo,
    postingDate: data?.postingDate,
  };
  return lmsClient({
    url: `/lms/SuspendSplit/GetListApprovalSuspendSplit?${buildQuery(params)}`,
    method: "get",
  });
};

export default SuspendSplit;
